<template>
  <div class="booking-box-previous-event">
    <div v-if="tempData.status">
      <div class="box1">
        <div class="item">
          <div class="title">Ref No.</div>
          <div class="text" v-text="tempData.id"></div>
        </div>
        <div class="item">
          <div class="title">Data</div>
          <div class="text" v-text="tempData.date"></div>
        </div>
        <div class="item">
          <dropdown-time-type-2
            v-model="tempData.reservation"
          ></dropdown-time-type-2>
        </div>
        <div class="item">
          <div class="title">Total Price</div>
          <div class="text">
            <span v-currency="tempData.currency"></span>
            {{ tempData.price }}
          </div>
        </div>
      </div>
      <div class="message-box">
        <div class="profile-image">
          <img v-imageLoading="tempData.photographerProfileImage" />
        </div>
        <div class="contents">
          <div class="author">
            Shooting with
            <span class="name" v-text="tempData.photographerName"></span>
          </div>
          <div class="comment" v-text="tempData.comment"></div>
        </div>
        <div v-if="tempData.status == 'uploaded'" class="buttons">
          <base-button-type-1
            v-if="!tempData.uploaded"
            text="WRITE REVIEW"
            type-color="white"
          ></base-button-type-1>
          <base-button-type-1
            @click="goToAlbum"
            text="ALBUM"
            type-color="blue"
          ></base-button-type-1>
        </div>
        <div v-else class="buttons">
          <button class="decline">Declined</button>
        </div>
      </div>
    </div>
    <div class="no-data" v-else>
      <div class="message">There is no Message</div>
    </div>
  </div>
</template>

<script>
import mixinPrice from '../../mixin/price'
import BaseButtonType1 from '../common/form-elemnets/BaseButtonType1'
import mixCommon from '../../mixin/common'
import DropdownTimeType2 from './DropdownTimeType2'

export default {
  components: { DropdownTimeType2, BaseButtonType1 },
  mixins: [mixinPrice, mixCommon],
  name: 'booking-box-previous-event',
  props: {
    data: {
      default: () => ({
        date: '@/components/2018',
        time: '15:00 - 17:00',
        refNo: '213',
        profileImage: require('@/assets/images/common/temp-profile.jpg'),
        edit: false,
        status: true,
        comment:
          'at Chantrey House, 98 Buckingham Palace Rd, Belgravia, London SW1W 0SS',
        photographerName: 'Miky',
        price: '140',
        currency: 'USD'
      }),
      type: Object
    }
  },
  data() {
    return {
      tempData: {}
    }
  },
  created() {
    this.tempData = this.data
    this.tempData.time = '15:00 - 17:00'
  },
  methods: {
    convertAMFM(time) {
      const hour = Number(time) - 1
      // console.log('time:', hour)
      const _time = hour < 10 ? `0${hour}:00` : `${hour}:00`
      const type = hour < 13 ? 'AM' : 'PM'
      return `${_time} ${type}`
    },
    convertTime(reservation) {
      if (typeof reservation != 'object') return
      console.log('reservation:', reservation)
      return new Promise(resolve => {
        const reservationFormTime = Object.keys(reservation)[0]
        const reservationEndTime = Object.values(reservation)[0].endTime
        resolve({
          fromTime: reservationFormTime,
          endTime: reservationEndTime
        })
      }).then(r => {
        const fromTime = r.fromTime / 60
        const endTime = r.endTime / 60
        return `${this.convertAMFM(fromTime / 60 + 1)} - ${this.convertAMFM(
          endTime / 60 + 1
        )}`
      })
    },
    goToAlbum() {
      this.$router.push({ path: '/user/album/detail/' + this.tempData.id })
    },
    buttonAction(actionName) {
      this.$emit('action', { action: actionName, data: this.tempData })
    }
  }
}
</script>

<style lang="scss" scoped>
.booking-box-previous-event {
  border: 1px solid #c8c8c8;
  .box1 {
    background-color: #f5f5f5;
    display: flex;
    border-bottom: 1px solid #c8c8c8;
    .item {
      text-overflow: ellipsis;
      overflow: hidden;
      height: 80px;
      &:nth-child(1) {
        border-right: 1px solid #c8c8c8;
        width: 181px;
      }

      &:nth-child(2) {
        width: 361px;
        border-right: 1px solid #c8c8c8;
      }

      &:nth-child(3) {
        width: 361px;
        border-right: 1px solid #c8c8c8;
      }

      &:nth-child(4) {
        width: 180px;
        border-right: 1px solid #c8c8c8;
      }

      .title {
        margin: 20px 0 0 20px;
        /*border: 1px solid red;*/
        font-weight: 600;
        font-size: 16px;
        letter-spacing: 1px;
      }

      .text {
        margin: 10px 0 0 20px;
        font-size: 16px;
        font-weight: 300;
        letter-spacing: 1px;
        font-family: Poppins;
        color: #000000;
      }
    }
  }
  .message-box {
    display: flex;
    justify-content: space-between;
    position: relative;
    .profile-image {
      width: 131px;
      height: 131px;
      position: relative;
      img {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        width: 100px;
        height: 100px;
      }
    }
    .contents {
      width: 70%;
      margin: 18px 0 18px 0;
      /*border: 1px dotted red;*/
      .author {
        font-weight: 600;
      }

      .comment {
        margin: 10px 0 0 0;
        width: 700px;
        height: 71px;
        /*border: 1px solid red;*/
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .buttons {
      width: 200px;
      display: flex;
      height: 151px;
      justify-content: space-evenly;
      flex-direction: column;
      align-items: center;
      .decline {
        width: 150px;
        height: 50px;
        font-size: 14px;
        font-weight: 300;
        letter-spacing: 1px;
        outline: none;
        border: 0;
        background-color: #ff3226;
        color: white;
        cursor: help;
      }
    }
  }
  .no-data {
    height: 200px;
    position: relative;
    .message {
      margin: auto;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 200px;
      text-align: center;
      height: 20px;
    }
    background-color: #f5f5f5;
  }
}
</style>
